import type { FunctionComponent } from 'react'

import { H2 } from '@monthio/design-system'
import { Chip, COLORS, MaterialIcons } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StatusWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`

export const FlowStatus: FunctionComponent<{
	coApplicantFinished: boolean
}> = ({ coApplicantFinished }) => {
	const { t } = useTranslation()

	const StatusChip = coApplicantFinished ? (
		<CoApplicantFinishedChip />
	) : (
		<CoApplicantWaitingChip />
	)

	return (
		<StatusWrapper>
			<H2>{t('status')}:</H2>
			{StatusChip}
		</StatusWrapper>
	)
}

const CoApplicantFinishedChip = () => {
	const { t } = useTranslation()

	return (
		<Chip
			label={t('genericLandingPage-coupleSeparateDeviceStart-status-ready')}
			icon={
				// TODO: Replace with check circle icon from design system when available
				<MaterialIcons.CheckCircleOutlined
					fontSize="small"
					style={{ color: COLORS.OTHER_COLORS.DARK_MONEY_GREEN }}
				/>
			}
			size="small"
			style={{
				backgroundColor: COLORS.OTHER_COLORS.AFFIRMATION_GREEN_LIGHTER,
				color: COLORS.OTHER_COLORS.DARK_MONEY_GREEN,
			}}
		/>
	)
}

// TODO: Maybe change to badge
const CoApplicantWaitingChip = () => {
	const { t } = useTranslation()

	return (
		<Chip
			label={t('genericLandingPage-coupleSeparateDeviceStart-status-waiting')}
			icon={
				// TODO: Replace with check circle icon from design system when available
				<MaterialIcons.WatchLaterOutlined
					fontSize="small"
					style={{ color: '#FF6B00' }}
				/>
			}
			size="small"
			style={{
				backgroundColor: '#FFEED9',
				color: '#FF6B00',
			}}
		/>
	)
}
